module.exports = __webpack_public_path__ + "img/box-ms.16383f56.png";